import React, { useState } from 'react';
import { fetchExportComponentXlsxById } from '../../../api/functionApi';

interface DownloadReportButtonProps {
  reportId: string;
  componentId: string;
}

const DownloadReportButton: React.FC<DownloadReportButtonProps> = ({ reportId, componentId }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);
      const blob = await fetchExportComponentXlsxById(reportId, componentId);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `report_${componentId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      console.error(error);
      alert('Errore nel download del report');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={loading}
        className="bg-textPrimary text-white hover:bg-textSecondary px-4 py-2 rounded-lg text-sm font-medium flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {loading ? 'Scaricando...' : 'Scarica Report'}
    </button>
  );
};

export default DownloadReportButton;
